import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./utils/request";
import api from "./common/api";
import Zh from "./assets/lang/zh";
import En from "./assets/lang/en";
import Th from "./assets/lang/th";
import VueI18n from "vue-i18n";
import "./utils/antd";
import "./assets/css/reset.css";
Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
Vue.use(VueI18n);

Vue.directive("drag-modal", (el, bindings, vnode) => {
  Vue.nextTick(() => {
    let { visible, destroyOnClose } = vnode.componentInstance;
    // 防止未定义 destroyOnClose 关闭弹窗时dom未被销毁，指令被重复调用
    if (!visible) return;
    let modal = el.getElementsByClassName("ant-modal")[0];
    let header = el.getElementsByClassName("header")[0];
    let left = 0;
    let top = 0;

    // 未定义 destroyOnClose 时，dom未被销毁，关闭弹窗再次打开，弹窗会停留在上一次拖动的位置
    if (!destroyOnClose) {
      left = modal.left || 0;
      top = modal.top || 0;
    }
    // top 初始值为 offsetTop
    top = top || modal.offsetTop;
    header.onmousedown = e => {
      let startX = e.clientX;
      let startY = e.clientY;
      header.left = header.offsetLeft;
      header.top = header.offsetTop;
      el.onmousemove = event => {
        let endX = event.clientX;
        let endY = event.clientY;
        modal.left = header.left + (endX - startX) + left;
        modal.top = header.top + (endY - startY) + top;
        modal.style.left = modal.left + "px";
        modal.style.top = modal.top + "px";
      };
      el.onmouseup = () => {
        left = modal.left;
        top = modal.top;
        el.onmousemove = null;
        el.onmouseup = null;
        header.releaseCapture && header.releaseCapture();
      };
      header.setCapture && header.setCapture();
    };
  });
});

const i18n = new VueI18n({
  locale: "zh", // 语言标识
  messages: {
    zh: Zh,
    en: En,
    th: Th
  }
});
Vue.prototype.$api = api;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
